module.exports = __webpack_public_path__ + "img/status0_icon1.a2642b5a.png";